import React, { useEffect } from 'react'
import useCallApi from '../../hooks/useCallApi'

export default function CurrencyDropdown({ currency, setCurrency, showSystemMessage, any }) {
    const { dataLoaded, data } = useCallApi(`forex/currencies`, 'GET', {}, [], showSystemMessage)

    return (
        (dataLoaded && data.currencies) ?
            <select
                className="form-control form-control-sm"
                value={currency}
                onChange={(e) => {
                    setCurrency(e.target.value)
                }}
            >
                {any && <option value="ANY">Any</option>}
                { data.currencies &&
                    data.currencies.map((curr) => {
                        return (
                            <option value={curr} key={curr}>
                                {curr}
                            </option>
                        )
                })}
            </select>
        :
            <select className="form-control form-control-sm"></select>
    )
}
